<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 bg-gradient-primary shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0" style="margin-top: auto;">
            <div class="row">
              <div class="col-lg-4">
                <card
                  class="border-0 d-flex card-sop"
                  hover
                  shadow
                  body-classes="text-center align-items-center d-flex justify-content-center"
                >
                  <object
                    data="/img/svg/13-SOP.svg"
                    type="image/svg+xml"
                    class="text-white card-pajak"
                  ></object>
                  <h6
                    class="text-white text-uppercase title-inside-card"
                    style="margin-top: 7px"
                  >SOP</h6>
                </card>
              </div>
              <div class="col-lg-8">
                <h1 class="display-3 text-white">
                  Informasi SOP Pajak Daerah
                  <span>Kabupaten Ketapang</span>
                </h1>
                <p
                  class="description mt-3 text-white"
                >Pajak Daerah adalah kontribusi wajib kepada daerah yang terutang oleh orang pribadi atau badan yang bersifat memaksa berdasarkan undang-undang dengan tidak mendapatkan imbalan secara langsung dan digunakan untuk keperluan daerah bagi sebesar-besarnya kemakmuran rakyat.</p>

                <p
                  class="description mt-3 text-white"
                >Pengertian tersebut termuat di dalam Undang-undang Pajak Daerah dan Retribusi Daerah Nomor 28 Tahun 2009.</p>
                <div class="btn-wrapper">
                  <base-button
                    tag="a"
                    class="mb-3 mb-sm-0"
                    type="info"
                    textColor="white"
                    icon="fa fa-arrow-left"
                    @click="goback()"
                  >Kembali</base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <br>
    <br>
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-6">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-floppy-o" type="primary" rounded class="mb-4"></icon>
                  <h6 class="text-primary text-uppercase">Self Assesment</h6>
                  <p class="description mt-3">
                    Self Assessment System merupakan sistem pemungutan pajak yang membebankan penentuan besaran pajak yang perlu dibayarkan oleh wajib pajak yang bersangkutan.
                    <br />
                    <br />
                  </p>
                  <base-button
                    textColor="white"
                    tag="a"
                    type="primary"
                    class="mt-4"
                    @click="sopSelf()"
                  >Lanjutkan</base-button>
                </card>
              </div>
              <div class="col-lg-6">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-print" type="info" rounded class="mb-4"></icon>
                  <h6 class="text-info text-uppercase">Official Assesment</h6>
                  <p
                    class="description mt-3"
                  >Official Assessment System merupakan sistem pemungutan pajak yang membebankan wewenang untuk menentukan besarnya pajak terutang pada fiskus atau aparat perpajakan sebagai pemungut pajak.</p>
                  <br />
                  <base-button
                    textColor="white"
                    tag="a"
                    type="info"
                    class="mt-4"
                    @click="sopOffice()"
                  >Lanjutkan</base-button>
                </card>
              </div>
            </div>
            <br />
            <div class="row row-grid">
              <div class="col-lg-6">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-save" type="success" rounded class="mb-4"></icon>
                  <h6 class="text-success text-uppercase">OP PBB Baru</h6>
                  <p
                    class="description mt-3"
                  >Prosedur Pendaftaran Objek Baru Pajak Bumi dan Bangunan.</p>
                  <br />
                  <base-button
                    textColor="white"
                    tag="a"
                    type="success"
                    class="mt-4"
                    @click="sopOpPbb()"
                  >Lanjutkan</base-button>
                </card>
              </div>
              <div class="col-lg-6">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-save" type="danger" rounded class="mb-4"></icon>
                  <h6 class="text-danger text-uppercase">Pelayanan Pendataan PBB</h6>
                  <p class="description mt-3">Prosedur Pelayanan Pendataan Objek Pajak Daerah.</p>
                  <br />
                  <base-button
                    textColor="white"
                    tag="a"
                    type="danger"
                    class="mt-4"
                    @click="sopPelayananPbb()"
                  >Lanjutkan</base-button>
                </card>
              </div>
            </div>
            <br />
            <div class="row row-grid">
              <div class="col-lg-6">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-save" type="warning" rounded class="mb-4"></icon>
                  <h6 class="text-warning text-uppercase">Pembayaran Pajak Daerah</h6>
                  <p class="description mt-3">Prosedur Pelayanan Pembayaran Pajak Daerah.</p>
                  <br />
                  <base-button
                    textColor="white"
                    tag="a"
                    type="warning"
                    class="mt-4"
                    @click="SopPembayaran()"
                  >Lanjutkan</base-button>
                </card>
              </div>
              <div class="col-lg-6">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-save" type="primary" rounded class="mb-4"></icon>
                  <h6 class="text-primary text-uppercase">Pelayanan Keberatan PBB P2</h6>
                  <p class="description mt-3">Pelayanan Pengajuan dan Penyelesaian Keberatan PBB P2.</p>
                  <br />
                  <base-button
                    textColor="white"
                    tag="a"
                    type="primary"
                    class="mt-4"
                    @click="SopKeberatan()"
                  >Lanjutkan</base-button>
                </card>
              </div>
            </div>
            <br />
            <div class="row row-grid">
              <div class="col-lg-6">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-save" type="info" rounded class="mb-4"></icon>
                  <h6 class="text-info text-uppercase">Pelayanan Penilaian Individu</h6>
                  <p class="description mt-3">Prosedur Pelayanan Penilaian Individu.</p>
                  <br />
                  <br />
                  <base-button
                    textColor="white"
                    tag="a"
                    type="info"
                    class="mt-4"
                    @click="SopIndividu()"
                  >Lanjutkan</base-button>
                </card>
              </div>
              <div class="col-lg-6">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-save" type="success" rounded class="mb-4"></icon>
                  <h6
                    class="text-success text-uppercase"
                  >Pengurangan Ketetapan dan Penghapusan PBB-P2</h6>
                  <p
                    class="description mt-3"
                  >Prosedur Pengurangan Ketetapan dan Penghapusan atau Pengurangan Sanksi Administratif Pajak Bumi dan Bangunan.</p>
                  <br />
                  <base-button
                    textColor="white"
                    tag="a"
                    type="success"
                    class="mt-4"
                    @click="SopPengurangan()"
                  >Lanjutkan</base-button>
                </card>
              </div>
            </div>
            <br />
            <div class="row row-grid">
              <div class="col-lg-6">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-save" type="danger" rounded class="mb-4"></icon>
                  <h6 class="text-danger text-uppercase">Pelayanan Pengurangan BPHTB</h6>
                  <p class="description mt-3">Prosedur Pelayanan Permohonan Pengurangan BPHTB.</p>
                  <br />
                  <br />
                  <base-button
                    textColor="white"
                    tag="a"
                    type="danger"
                    class="mt-4"
                    @click="SopPenugranganBphtb()"
                  >Lanjutkan</base-button>
                </card>
              </div>
              <div class="col-lg-6">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-save" type="warning" rounded class="mb-4"></icon>
                  <h6 class="text-warning text-uppercase">Pelayanan Pengembalian BPHTB</h6>
                  <p
                    class="description mt-3"
                  >Prosedur Pelayananan Pengembalian Keleibhanan Pembayaran BPHTB.</p>
                  <br />
                  <base-button
                    textColor="white"
                    tag="a"
                    type="warning"
                    class="mt-4"
                    @click="SopKelebihanBphtb()"
                  >Lanjutkan</base-button>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <br />
    <br />
    <sop-self ref="sop-self" title="SOP Pajak Daerah Self Assesment System"></sop-self>
    <sop-office ref="sop-office" title="SOP Pajak Daerah Office Assesment System"></sop-office>
    <sop-op-pbb ref="sop-op-pbb"></sop-op-pbb>
    <sop-pelayanan-pbb ref="sop-pelayanan-pbb"></sop-pelayanan-pbb>
    <sop-pembayaran ref="sop-pembayaran"></sop-pembayaran>
    <sop-keberatan ref="sop-keberatan"></sop-keberatan>
    <sop-individu ref="sop-individu"></sop-individu>
    <sop-pengurangan ref="sop-pengurangan"></sop-pengurangan>
    <sop-pengurangan-bphtb ref="sop-pengurangan-bphtb"></sop-pengurangan-bphtb>
    <sop-kelebihan-bphtb ref="sop-kelebihan-bphtb"></sop-kelebihan-bphtb>
  </div>
</template>

<script>
import SopSelf from "../views/GlobalPage/SopSelf";
import SopOffice from "../views/GlobalPage/SopOffice";
import SopOpPbb from "../views/GlobalPage/SopNopBaru";
import SopPelayananPbb from "../views/GlobalPage/SopPelayananPbb";
import SopPembayaran from "../views/GlobalPage/SopPembayaran";
import SopKeberatan from "../views/GlobalPage/SopKeberatan";
import SopIndividu from "../views/GlobalPage/SopPelayananIndividu";
import SopPengurangan from "../views/GlobalPage/SopPengurangan";
import SopPenguranganBphtb from "../views/GlobalPage/SopPenguranganBphtb";
import SopKelebihanBphtb from "../views/GlobalPage/SopKelebihanBphtb";
export default {
  name: "Sop",
  components: {
    SopSelf,
    SopOffice,
    SopOpPbb,
    SopPelayananPbb,
    SopPembayaran,
    SopKeberatan,
    SopIndividu,
    SopPengurangan,
    SopPenguranganBphtb,
    SopKelebihanBphtb,
  },
  data() {
    return {
      css: CssForBootstrap4,
      items: [],
    };
  },
  methods: {
    sopSelf() {
      this.$refs["sop-self"].showModal();
    },
    sopOffice() {
      this.$refs["sop-office"].showModal();
    },
    sopOpPbb() {
      this.$refs["sop-op-pbb"].showModal();
    },
    sopPelayananPbb() {
      this.$refs["sop-pelayanan-pbb"].showModal();
    },
    SopPembayaran() {
      this.$refs["sop-pembayaran"].showModal();
    },
    SopKeberatan() {
      this.$refs["sop-keberatan"].showModal();
    },
    SopIndividu() {
      this.$refs["sop-individu"].showModal();
    },
    SopPengurangan() {
      this.$refs["sop-pengurangan"].showModal();
    },
    SopPenugranganBphtb() {
      this.$refs["sop-pengurangan-bphtb"].showModal();
    },
    SopKelebihanBphtb() {
      this.$refs["sop-kelebihan-bphtb"].showModal();
    },
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.section-shaped .shape.shape-skew + .shape-container {
  padding-top: 9rem;
  padding-bottom: 14rem;
}

.card-sop {
  height: 100%;
}

.chart-wrapper {
  position: relative;
  padding-bottom: 40%;
}

.chart-inner {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>